import React from "react";

const inputCls = "w-full bg-[#16161D] border border-white/10 rounded-lg px-3 py-2 text-white text-sm";

export function TagsInput({ value = [], onChange, testid = "tags", small }) {
  const tags = [value[0] || "", value[1] || "", value[2] || ""];
  const set = (i, v) => {
    const next = [...tags];
    next[i] = v;
    onChange(next);
  };
  return (
    <div className="grid grid-cols-3 gap-2">
      {tags.map((t, i) => (
        <input key={i} className={small ? "bg-[#16161D] border border-white/10 rounded-lg px-2 py-1.5 text-white text-xs w-full" : inputCls}
          placeholder={`Tag ${i + 1}`} value={t} data-testid={`${testid}-${i + 1}`}
          onChange={(e) => set(i, e.target.value)} />
      ))}
    </div>
  );
}

export const tagsToForm = (tags) => (tags || []).map((t) => t.trim()).filter(Boolean).join(",");
